import { useState } from "react";

import { Button, Radio, Row } from "@narmi/design_system";

import styles from "./RadioButtonsFilterPanel.module.scss";

export interface RadioButtonsFilterPanelProps {
  applyLabel: string;
  close: () => void;
  onApply: () => void;
  options: { value: string; label: string }[];
  removeLabel: string;
  selectedValue: string | null;
  setSelectedValue: (value: string | null) => void;
  testIdPrefix: string;
}

const RadioButtonsFilterPanel = ({
  applyLabel,
  close,
  onApply,
  options,
  removeLabel,
  selectedValue,
  setSelectedValue,
  testIdPrefix,
}: RadioButtonsFilterPanelProps) => {
  const [draft, setDraft] = useState<string | null>(selectedValue);

  const handleApply = () => {
    setSelectedValue(draft);
    onApply();
    close();
  };

  const handleRemove = () => {
    setDraft(null);
    setSelectedValue(null);
    onApply();
    close();
  };

  return (
    <div className={styles["radio-buttons-filter-panel"]}>
      <div className={styles["radio-buttons-filter-panel-list"]}>
        {options.map((option) => (
          <div
            key={option.value}
            className={styles["radio-buttons-filter-panel-option"]}
          >
            <Radio
              name="radio-buttons-filter-panel"
              value={option.value}
              onCheck={setDraft}
              checked={draft === option.value}
            >
              {option.label}
            </Radio>
          </div>
        ))}
      </div>
      <div className={styles["radio-buttons-filter-panel-divider"]} />
      <div className="padding--x--s padding--y--xs">
        <Row justifyContent="space-between" alignItems="center">
          <Button
            kind="plain"
            size="s"
            label={removeLabel}
            onClick={handleRemove}
            type="button"
            testId={`${testIdPrefix}-remove`}
          />
          <Button
            kind="primary"
            size="s"
            label={applyLabel}
            onClick={handleApply}
            type="button"
            testId={`${testIdPrefix}-apply`}
          />
        </Row>
      </div>
    </div>
  );
};

export default RadioButtonsFilterPanel;
